import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { toast, ToastContainer } from "react-toastify";

function SubLedgerMaster(props) {
  const [subLedgers, setSubLedgers] = useState([]);
  const [SubAcCode, setSubAcCode] = useState('');
  const [SubLedgerGroupCode, setSubLedgerGroupCode] = useState('');
  const [SubLedgerGroupName, setSubLedgerGroupName] = useState('');
  const [SubSrNo, setSubSrNo] = useState('');
  const [SubAcHead, setSubAcHead] = useState('');
  const [SubAcHeadEng, setSubAcHeadEng] = useState('');
  const [Address1, setAddress1] = useState('');
  const [Address2, setAddress2] = useState('');
  const [StateCode, setStateCode] = useState('');
  const [StateName, setStateName] = useState('');
  const [PhoneNo, setPhoneNo] = useState('');
  const [MobileNo, setMobileNo] = useState('');
  const [Email, setEmail] = useState('');
  const [AadharCardNo, setAadharCardNo] = useState('');
  const [BankName, setBankName] = useState('');
  const [BankAcNo, setBankAcNo] = useState('');
  const [PANo, setPANo] = useState('');
  const [GSTNO, setGSTNO] = useState('');
  const [Remark1, setRemark1] = useState('');
  const [Remark2, setRemark2] = useState('');
  const [Remark3, setRemark3] = useState('');
  const [StatusCode, setStatusCode] = useState('1');
  const [USERID, setUSERID] = useState('');

  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [initialData, setInitialData] = useState([]);
  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const [formMode, setFormMode] = useState('add');
  const [editSubLedgerId, setEditSubLedgerId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [subLedgerMasterEntries, setSubLedgerMasterEntries] = useState([]);
  const [SubLedgerGroupMasterEntries, setSubLedgerGroupMasterEntries] = useState([]);
  const [StateMasterEntries, setStateMasterEntries] = useState([]);

  useEffect(() => {
    fetchSubLedgerMaster();
    fetchSubLedgerGroupMaster();
    fetchStateMaster();
  }, []);

  const fetchSubLedgerMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/subledgerMaster');
      setSubLedgerMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = Number(maxEntryNo) + 1;
      setSubAcCode(nextEntryNo);
      setInitialData(response.data);
      //console.log("Subledgermaster ", response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      const subAcCode = parseInt(entry.SubAcCode);
      if (subAcCode > maxEntryNo) {
        maxEntryNo = subAcCode;
      }
    }
    return maxEntryNo;
  };


  const fetchSubLedgerGroupMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/subledgergroups');
      setSubLedgerGroupMasterEntries(response.data);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchStateMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/states');
      setStateMasterEntries(response.data);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const addSubLedger = async () => {
    if ((!props.canAdd)) {
              const action = "Save";
              toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
              return;
            }
     if (!SubAcHead.trim()) {
          toast.warn("Error: Party Name is required.", {autoClose:700});
          return; 
        }
    try {
      await axios.post('https://www.wingap.net.in/api/subledgerMaster', {
        SubAcCode: SubAcCode,
        SubLedgerGroupCode: SubLedgerGroupCode,
        SubSrNo: SubSrNo,
        SubAcHead: SubAcHead,
        SubAcHeadEng: SubAcHeadEng,
        Address1: Address1,
        Address2: Address2,
        StateCode: StateCode,
        PhoneNo: PhoneNo,
        MobileNo: MobileNo,
        Email: Email,
        AadharCardNo: AadharCardNo,
        BankName: BankName,
        BankAcNo: BankAcNo,
        PANo: PANo,
        GSTNO: GSTNO,
        Remark1: Remark1,
        Remark2: Remark2,
        Remark3: Remark3,
        StatusCode: StatusCode,
        USERID: props.name,
      });
      fetchSubLedgerMaster();
      // Reset all state variables to clear the form
      setSubAcCode('');
      setSubLedgerGroupCode('');
      setSubSrNo('');
      setSubAcHead('');
      setSubAcHeadEng('');
      setAddress1('');
      setAddress2('');
      setStateCode('');
      setPhoneNo('');
      setMobileNo('');
      setEmail('');
      setAadharCardNo('');
      setBankName('');
      setBankAcNo('');
      setPANo('');
      setGSTNO('');
      setRemark1('');
      setRemark2('');
      setRemark3('');
      setStatusCode('1');
      setUSERID('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateSubLedger = async (SubAcCode) => {
    if ((!props.canEdit)) {
              const action = "Update";
              toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
              return;
            }
    if (!SubAcHead.trim()) {
      toast.warn("Error: Party Name is required.", {autoClose:700});
      return; 
    }
    try {
      await axios.put(`https://www.wingap.net.in/api/subledgerMaster/${SubAcCode}`, {
        SubAcCode: SubAcCode,
        SubLedgerGroupCode: SubLedgerGroupCode,
        SubSrNo: SubSrNo,
        SubAcHead: SubAcHead,
        SubAcHeadEng: SubAcHeadEng,
        Address1: Address1,
        Address2: Address2,
        StateCode: StateCode,
        PhoneNo: PhoneNo,
        MobileNo: MobileNo,
        Email: Email,
        AadharCardNo: AadharCardNo,
        BankName: BankName,
        BankAcNo: BankAcNo,
        PANo: PANo,
        GSTNO: GSTNO,
        Remark1: Remark1,
        Remark2: Remark2,
        Remark3: Remark3,
        StatusCode: StatusCode,
        USERID: props.name
      });
      fetchSubLedgerMaster();
      // Reset all state variables to clear the form
      setSubAcCode('');
      setSubLedgerGroupCode('');
      setSubSrNo('');
      setSubAcHead('');
      setSubAcHeadEng('');
      setAddress1('');
      setAddress2('');
      setStateCode('');
      setPhoneNo('');
      setMobileNo('');
      setEmail('');
      setAadharCardNo('');
      setBankName('');
      setBankAcNo('');
      setPANo('');
      setGSTNO('');
      setRemark1('');
      setRemark2('');
      setRemark3('');
      setStatusCode('1');
      setUSERID('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteSubLedger(deleteEntryNo.SubAcCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteSubLedger = async (SubAcCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/subledgerMaster/${SubAcCode}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchSubLedgerMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };

  const setEditForm = (subLedger) => {
    setFormMode('edit');
    setSubAcCode(subLedger.SubAcCode);
    setSubLedgerGroupCode(subLedger.SubLedgerGroupCode);
    setSubSrNo(subLedger.SubSrNo);
    setSubAcHead(subLedger.SubAcHead);
    setSubAcHeadEng(subLedger.SubAcHeadEng);
    setAddress1(subLedger.Address1);
    setAddress2(subLedger.Address2);
    setStateCode(subLedger.StateCode);
    setPhoneNo(subLedger.PhoneNo);
    setMobileNo(subLedger.MobileNo);
    setEmail(subLedger.Email);
    setAadharCardNo(subLedger.AadharCardNo);
    setBankName(subLedger.BankName);
    setBankAcNo(subLedger.BankAcNo);
    setPANo(subLedger.PANo);
    setGSTNO(subLedger.GSTNO);
    setRemark1(subLedger.Remark1);
    setRemark2(subLedger.Remark2);
    setRemark3(subLedger.Remark3);
    setStatusCode(subLedger.StatusCode);
    setUSERID(subLedger.USERID);
    setShowGrid(false);
    const selectedGroup = SubLedgerGroupMasterEntries.find(group => group.SubLedgerGroupCode === subLedger.SubLedgerGroupCode);
    if (selectedGroup) {
      setSubLedgerGroupName(selectedGroup.SubLedgerGroupName);
    }
    const selectedGroup1 = StateMasterEntries.find(group => group.StateCode === subLedger.StateCode);
    if (selectedGroup1) {
      setStateName(selectedGroup1.StateName);
    }
  };

  const handleSearch = (searchQuery) => {
    if (!searchQuery) {
      setSubLedgerMasterEntries(initialData); 
    } else {
      const lowercasedQuery = searchQuery.toLowerCase();
      const filtered = initialData.filter((entry) => {
        const partycode = entry.SubAcCode;
  
        const partyNameEntry = initialData.find(
          (partyEntry) => partyEntry.SubAcCode === partycode
        );
        const partyName = partyNameEntry ? partyNameEntry.SubAcHead.toLowerCase() : '';
        return partyName.includes(lowercasedQuery);
      });
      setSubLedgerMasterEntries(filtered);
    }
  };
  
  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery]); 

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setSubLedgers(subLedgers);
    setSubLedgerGroupCode(SubLedgerGroupMasterEntries[0].SubLedgerGroupCode);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditSubLedgerId('');
    setSubAcCode('');
    setSubLedgerGroupCode('');
    setSubSrNo('');
    setSubAcHead('');
    setSubAcHeadEng('');
    setAddress1('');
    setAddress2('');
    setStateCode('');
    setPhoneNo('');
    setMobileNo('');
    setEmail('');
    setAadharCardNo('');
    setBankName('');
    setBankAcNo('');
    setPANo('');
    setGSTNO('');
    setRemark1('');
    setRemark2('');
    setRemark3('');
    setStatusCode('1');
    setUSERID('');
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "SubLedgerData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <ToastContainer/>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Party Master</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
          <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px', width: '50%' }}>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="SubAcCode" style={{ width: '150px', marginRight: '10px' }}>SubAcCode</label>
                <input
                  type="text"
                  value={SubAcCode}
                  readOnly
                  placeholder="SubAcCode"
                  style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="SubLedgerGroupName" style={{ width: '150px', marginRight: '10px' }}>SubLedgerGroupName</label>
                <select
                  value={SubLedgerGroupCode}
                  onChange={(e) => {
                    const selectedGroupName = e.target.value;
                    setSubLedgerGroupCode(selectedGroupName);
                    const selectedGroup = SubLedgerGroupMasterEntries.find(group => group.SubLedgerGroupCode === selectedGroupName);
                    if (selectedGroup) {
                      setSubLedgerGroupCode(selectedGroup.SubLedgerGroupCode);
                    }
                  }}
                  style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
                >{
                    SubLedgerGroupMasterEntries.map((group) => (
                      <option key={group.SubLedgerGroupCode} value={group.SubLedgerGroupCode}>{group.SubLedgerGroupName}</option>
                    ))
                  }</select>
                <input
                  type="text"
                  value={SubLedgerGroupCode}
                  onChange={(e) => {
                    setSubLedgerGroupCode(e.target.value)

                    const correspondingGroup = SubLedgerGroupMasterEntries.find(group => group.SubLedgerGroupCode === e.target.value);
                    if (correspondingGroup) {
                      setSubLedgerGroupName(correspondingGroup.SubLedgerGroupName);
                    } else {
                      setSubLedgerGroupName('');
                    }
                  }}
                  placeholder="SubLedgerGroupCode"
                  style={{ marginLeft: '10px', marginBottom: '5px', padding: '4px', width: '13%' }}
                />
              </div>

              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="PartyName" style={{ width: '150px', marginRight: '10px' }}>PartyName</label>
                <input
                  type="text"
                  value={SubAcHead}
                  onChange={(e) => setSubAcHead(e.target.value)}
                  placeholder="PartyName"
                  style={{ marginBottom: '5px', padding: '5px', width: '60%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="PartyNameEng" style={{ width: '150px', marginRight: '10px' }}>PartyNameEng</label>
                <input
                  type="text"
                  value={SubAcHeadEng}
                  onChange={(e) => setSubAcHeadEng(e.target.value)}
                  placeholder="PartyNameEnglish"
                  style={{ marginBottom: '5px', padding: '5px', width: '60%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="Address1" style={{ width: '150px', marginRight: '10px' }}>Address1</label>
                <input
                  type="text"
                  value={Address1}
                  onChange={(e) => setAddress1(e.target.value)}
                  placeholder="Address1"
                  style={{ marginBottom: '5px', padding: '5px', width: '60%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="Address2" style={{ width: '150px', marginRight: '10px' }}>Address2</label>
                <input
                  type="text"
                  value={Address2}
                  onChange={(e) => setAddress2(e.target.value)}
                  placeholder="Address2"
                  style={{ marginBottom: '5px', padding: '5px', width: '60%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="GSTNO" style={{ width: '150px', marginRight: '10px' }}>GSTNO</label>
                <input
                  type="text"
                  value={GSTNO}
                  onChange={(e) => setGSTNO(e.target.value)}
                  placeholder="GSTNO"
                  style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="Remark1" style={{ width: '150px', marginRight: '10px' }}>Remark1</label>
                <input
                  type="text"
                  value={Remark1}
                  onChange={(e) => setRemark1(e.target.value)}
                  placeholder="Remark1"
                  style={{ marginBottom: '5px', padding: '5px', width: '50%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="StatusCode" style={{ width: '150px', marginRight: '10px' }}>StatusCode</label>
                <input
                  type="text"
                  value={StatusCode}
                  onChange={(e) => setStatusCode(e.target.value)}
                  placeholder="StatusCode"
                  style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
                />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '4px', width: '50%' }}>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="PhoneNo" style={{ width: '150px', marginRight: '10px' }}>PhoneNo</label>
                <input
                  type="text"
                  value={PhoneNo}
                  onChange={(e) => setPhoneNo(e.target.value)}
                  placeholder="PhoneNo"
                  style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="MobileNo" style={{ width: '150px', marginRight: '10px' }}>MobileNo</label>
                <input
                  type="text"
                  value={MobileNo}
                  onChange={(e) => setMobileNo(e.target.value)}
                  placeholder="MobileNo"
                  style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="Email" style={{ width: '150px', marginRight: '10px' }}>Email</label>
                <input
                  type="text"
                  value={Email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="AadharCardNo" style={{ width: '150px', marginRight: '10px' }}>AadharCardNo</label>
                <input
                  type="text"
                  value={AadharCardNo}
                  onChange={(e) => setAadharCardNo(e.target.value)}
                  placeholder="AadharCardNo"
                  style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="BankName" style={{ width: '150px', marginRight: '10px' }}>BankName</label>
                <input
                  type="text"
                  value={BankName}
                  onChange={(e) => setBankName(e.target.value)}
                  placeholder="BankName"
                  style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="BankAcNo" style={{ width: '150px', marginRight: '10px' }}>BankAcNo</label>
                <input
                  type="text"
                  value={BankAcNo}
                  onChange={(e) => setBankAcNo(e.target.value)}
                  placeholder="BankAcNo"
                  style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
                />
              </div>
              <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                <label htmlFor="PANo" style={{ width: '150px', marginRight: '10px' }}>PANo</label>
                <input
                  type="text"
                  value={PANo}
                  onChange={(e) => setPANo(e.target.value)}
                  placeholder="PANo"
                  style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
                />
              </div>
            </div>
          </div>
          <div>
            <button
              className={formMode === 'add' ? 'add-button' : 'update-button'}
              onClick={formMode === 'add' ? addSubLedger : () => updateSubLedger(SubAcCode)}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginBottom: '10px',borderRadius:'5px'
              }}
            >
              {formMode === 'add' ? 'Add' : 'Update'}
            </button>
            <button
              className="view-button"
              onClick={handleCancel}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginLeft: '10px',
                marginBottom: '10px',borderRadius:'5px'
              }}
            >
              Cancel
            </button>
          </div>
        </>
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SubAcCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SubLedgerGroup
                </th>

                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  PartyName
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  StatusCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {subLedgerMasterEntries
                .sort((a, b) => b.SubAcCode - a.SubAcCode)
                .map((subLedger) => {
                  const subledgergroup = SubLedgerGroupMasterEntries.find(entry => entry.SubLedgerGroupCode == subLedger.SubLedgerGroupCode)?.SubLedgerGroupName || '';
                  return (
                    <tr key={subLedger.SubAcCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{subLedger.SubAcCode}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{subledgergroup}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{subLedger.SubAcHead}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{subLedger.StatusCode}</td>
                      <td className="print-hide" style={{ border: '1px solid #ccc' }}>
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(76, 175, 80)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            marginRight: '5px',
                            marginLeft: '10px',
                          }}
                          onClick={() => setEditForm(subLedger)}
                        >
                          Edit
                        </button>
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(244, 67, 54)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setDeleteEntryNo({ SubAcCode: subLedger.SubAcCode });
                            setOpenConfirmation(true);
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>

          <Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                DELETE
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{ fontSize: '16px' }} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>
    </div>

  );
}

export default SubLedgerMaster;
